module.exports = __webpack_public_path__ + "img/C06TechLargeGarden_ua.72cc4f9f.webp";